var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52856 8.37134H1V22.1927H6.52856V8.37134Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5627 9.64594C22.0522 8.84798 21.1817 8.37142 20.2344 8.37142H15.0807L16.9232 1H14.8216C13.9562 1 13.1295 1.41354 12.6102 2.10571L7.4502 8.98583V22.1928H16.4068C17.4812 22.1928 18.4664 21.5626 18.9168 20.587L22.7444 12.2941C23.1414 11.4339 23.0735 10.4439 22.5631 9.64594H22.5627Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.771edfac1805ee34fc1a5a105ad02bb1.svg";
export { ForwardRef as ReactComponent };